module.exports = __webpack_public_path__ + "img/otd_prof.1d0a1d08.png";